import {type Stripe, type StripeElements} from '@stripe/stripe-js';
import {displayTokenizeError} from '../../checkout';
import {type PaymentData} from '../../../../@shared/ts/paymentAttempt';
import {type TransactionUpdate} from '../../../../@shared/ts/transaction';

interface StripePaymentData extends PaymentData {
	intermediate_url: string;
	data: {
		id: string;
		client_secret: string;
	};
}

type TokenResult = [paymentMethodId: string | null, update: TransactionUpdate];
type ConfirmResult = [status: 'success' | null, update: TransactionUpdate];

abstract class AbstractStripePayment {
	protected stripe: Readonly<Stripe>;
	protected elements: Readonly<StripeElements>;

	constructor(stripe: Stripe, elements: StripeElements) {
		this.stripe = stripe;
		this.elements = elements;
	}

	public init(): Promise<void> | void {
		// Empty so not undefined.
	}

	/**
	 * For setting up future payment methods without an immediate payment for Woocommerce. Only limited to Stripe Card for now.
	 * @param _sessionId Session id.
	 */
	public async setupToken(): Promise<TokenResult> {
		throw new Error('This method does not support setup tokens');
	}

	public displayPaymentError(message: string): void {
		displayTokenizeError(message);
	}

	public abstract gatewayId(): string;
	public abstract tokenize(): Promise<TokenResult>;
	public abstract confirm(clientSecret: string, intermediateURL?: string): Promise<ConfirmResult>;
}

export {
	type StripePaymentData,
	type TokenResult,
	type ConfirmResult,
	AbstractStripePayment,
};
